var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTcLogOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8543 13.7497V8.24968C20.8543 3.27218 18.7277 1.14551 13.7502 1.14551L8.25016 1.14551C3.27266 1.14551 1.146 3.27218 1.146 8.24968L1.146 13.7497C1.146 18.7272 3.27266 20.8538 8.25016 20.8538L13.7502 20.8538C18.7277 20.8538 20.8543 18.7272 20.8543 13.7497ZM2.521 8.24968C2.521 4.02384 4.02433 2.52051 8.25016 2.52051L13.7502 2.52051C17.976 2.52051 19.4793 4.02384 19.4793 8.24968V13.7497C19.4793 17.9755 17.976 19.4788 13.7502 19.4788L8.25016 19.4788C4.02433 19.4788 2.521 17.9755 2.521 13.7497L2.521 8.24968Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9884 10.9997C13.9884 10.8255 13.9243 10.6513 13.7868 10.5138L11.0368 7.76383C10.7709 7.498 10.3309 7.498 10.0651 7.76383C9.79926 8.02966 9.79926 8.46966 10.0651 8.73549L12.3293 10.9997L10.0651 13.2638C9.79926 13.5297 9.79926 13.9697 10.0651 14.2355C10.3309 14.5013 10.7709 14.5013 11.0368 14.2355L13.7868 11.4855C13.9243 11.348 13.9884 11.1738 13.9884 10.9997Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9881 11C13.9881 10.6242 13.6765 10.3125 13.3006 10.3125L5.96729 10.3125C5.59145 10.3125 5.27979 10.6242 5.27979 11C5.27979 11.3758 5.59145 11.6875 5.96729 11.6875L13.3006 11.6875C13.6856 11.6875 13.9881 11.3758 13.9881 11Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7107 10.9996C16.7107 9.06542 16.399 7.12209 15.7848 5.27959C15.6657 4.92209 15.2715 4.72958 14.914 4.84875C14.5565 4.96792 14.3548 5.35292 14.4832 5.71958C15.6198 9.12958 15.6198 12.8787 14.4832 16.2887C14.364 16.6462 14.5565 17.0404 14.914 17.1596C15.2715 17.2788 15.6657 17.0863 15.7848 16.7288C16.4082 14.8771 16.7107 12.9338 16.7107 10.9996Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcLogOutIcon);
export default __webpack_public_path__ + "static/media/tc_log_out_icon.80a6d092088a4dfb19fe650d012235b5.svg";
export { ForwardRef as ReactComponent };